
import stringMixin from './stringMixin';

export default {
  name: 'XhTextarea', // 新建 textarea
  components: {},
  mixins: [stringMixin],
  props: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},

  methods: {}
};